import ModalComponent from 'src/components/Modal/ModalComponent';
import FormSingleSearch from 'src/features/AIHSCodeLabeling/FormSingleSearch';
import { useSingleHSCodePredictionStore } from 'src/zustand/useAILabelingStore';

const FormAdjustment = () => {
  const { visiblePopupMatchAgain, dispatch } = useSingleHSCodePredictionStore();

  return (
    <ModalComponent
      showCloseIcon
      styleBox={{ width: 600 }}
      open={visiblePopupMatchAgain}
      handleClose={() => dispatch(false, 'visiblePopupMatchAgain')}
    >
      <FormSingleSearch />
    </ModalComponent>
  );
};

export default FormAdjustment;
